import styled from 'styled-components';

const Container = styled.div({
  '.capital': {
    textTransform: 'capitalize',
  },
});
export default Container;
